import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { WorkedTimesActionTypes } from '../State/actions/worked-times.actions';
import {
    getWorkedTimesFetched,
    getWorkedTimesLatestUpdatedAt,
    selectAreCommissionsLoaded, selectAreWorkDaysLoaded,
} from '../State/selectors/worked-times.selectors';
import { BaseEntityReloadResolver2 } from './resolver.helper';
import { combineLatest, Observable, of, switchMap } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class WorkedTimesResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getWorkedTimesFetched, getWorkedTimesLatestUpdatedAt, WorkedTimesActionTypes.Load, store);
    }
}


export const WorkedTimesByIdsResolverWithoutRoute: (
    store: Store<State>,
    workedTimesResolver: WorkedTimesResolver,
    commissionIds: number[],
    workDayIds: number[],
) => Observable<boolean> = (store, workedTimesResolver, commissionIds, workDayIds) => {
    if (!commissionIds.length && !workDayIds.length) return of(false);

    return store.select(getWorkedTimesFetched).pipe(
        take(1),
        switchMap((allFetched) => {
            if (allFetched) {
                return workedTimesResolver.resolve();
            }

            store.dispatch(WorkedTimesActionTypes.LoadFiltered({ commissionIds, workDayIds }));

            return combineLatest([
                store.select(selectAreCommissionsLoaded(commissionIds)),
                store.select(selectAreWorkDaysLoaded(workDayIds)),
            ]).pipe(
                filter(([c, w]) => c && w),
                take(1),
                map(() => true),
            );
        }),
    );
};

